/*
 * Copyright (c) 2024 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
import { countries as countriesData } from 'countries-list'

/** A country with a code and name. */
type Country = {
  /** The country code (ISO 3166-1 alpha-2), i.e. US, GB. */
  code: string

  /** The country name. */
  name: string
}

/** The list of countries. */
const countries: Country[] = Object.entries(countriesData)
  .map(([code, data]) => ({
    code,
    name: data.name,
  }))
  .sort((a, b) => a.name.localeCompare(b.name))

/**
 * Gets the default country for a given locale.
 *
 * @param locale - the locale to get the default country for
 */
const getCountryByLocale = (locale: string): Country => {
  const countryCode = locale.split('-')[1] || 'US'
  return countries.find((country) => country.code === countryCode) || countries[0]
}

/**
 * Gets a country by its code.
 *
 * @param code - the country code
 */
const getCountryByCode = (code: string): Country => {
  return countries.find((country) => country.code === code) || countries[0]
}

export { countries, getCountryByCode, getCountryByLocale }
export type { Country }
